$(document).ready(function(){
  

    const loopUntilMmqButtonIsReady = setInterval(() => {
        const embed = document.querySelector('mmq-embed');
        const variantUI = embed?.querySelector('mmq-variant-ui');
        const canvasButtons = variantUI?.shadowRoot?.querySelector('mmq-canvas-buttons');
        const zoomAll = canvasButtons?.shadowRoot?.querySelector('mmq-zoom-all');
        const quickIcon = zoomAll?.shadowRoot?.querySelector('mmq-quick-icon-button');
        const mmqButton = quickIcon?.shadowRoot?.querySelector('mmq-button');
      
        if (!mmqButton || !mmqButton.shadowRoot) {
          return;
        }
      
        const style = document.createElement('style');
        style.textContent = `
          :host {
            --mmq-button-background: rgba(255, 255, 255, 0.7) !important;
            --mmq-button-text-color: #19191C !important;
      
            background-color: rgba(255, 255, 255, 0.7) !important;
            color: #19191C !important;
          }
      
          :host(:hover) {
            --mmq-button-background: white !important;
      
            background-color: white !important;
          }
        `;
      
        mmqButton.shadowRoot.appendChild(style);
        clearInterval(loopUntilMmqButtonIsReady);
      }, 50);
  
  
  
      const loopUntilNestedButtonsReady = setInterval(() => {
        const embed = document.querySelector('mmq-embed');
        const variantUI = embed?.querySelector('mmq-variant-ui');
        const canvasButtons = variantUI?.shadowRoot?.querySelector('mmq-canvas-buttons');
        const zoomButtons = canvasButtons?.shadowRoot?.querySelector('mmq-zoom-buttons');
      
        if (!zoomButtons || !zoomButtons.shadowRoot) return;
      
        const quickButtons = zoomButtons.shadowRoot.querySelectorAll('mmq-quick-icon-button');
        if (!quickButtons.length) return;
      
        let styledCount = 0;
      
        quickButtons.forEach((quickIcon, i) => {
          const mmqButton = quickIcon.shadowRoot?.querySelector('mmq-button');
          const buttonRoot = mmqButton?.shadowRoot;
      
          if (!buttonRoot) {
            // console.log(`⏳ <mmq-button> #${i + 1} not ready yet...`);
            return;
          }
      
          // Prevent duplicate styling
          if (buttonRoot.querySelector('style[data-nested-style]')) return;
      
          const style = document.createElement('style');
          style.setAttribute('data-nested-style', 'true');
          style.textContent = `
            :host {
              --mmq-button-background: rgba(255, 255, 255, 0.7) !important;
              --mmq-button-text-color: #19191C !important;
              background-color: rgba(255, 255, 255, 0.7) !important;
              color: #19191C !important;
            }
      
            :host(:hover) {
              --mmq-button-background: white !important;
              background-color: white !important;
            }
          `;
          buttonRoot.appendChild(style);
          styledCount++;
        });
      
        // ✅ Stop only when all buttons are styled
        if (styledCount === quickButtons.length) {
          clearInterval(loopUntilNestedButtonsReady);
          console.log(`✅ Styled ${styledCount} nested <mmq-button> elements`);
        }
      }, 100);
      
   
      // window.mimeeqApp.config.icons = {
      //   optionPanel: {
      //     plus: '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M14 7L-2.55076e-07 7" stroke="#19191C"/> <path d="M7 0L7 14" stroke="#19191C"/> </svg>',
      //     minus: '<svg width="14" height="2" viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M14 1L-2.55076e-07 0.999999" stroke="#19191C"/> </svg>',
      //     expand: '<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M18 7.74414H10.9357V0.679883" stroke="#19191C"/> <path d="M0.618164 11.4048L7.68242 11.4048L7.68242 18.469" stroke="#19191C"/> </svg>'
      //   }
      // };
  });
  
  // Initialize Mimeeq with custom Material Design icons
  window.mimeeqAppConfig = {
  icons: {
    // Quick icon toolbar icons
    quickIcons: {
      zoomAll: '<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M18 7.74414H10.9357V0.679883" stroke="#19191C"/> <path d="M0.618164 11.4048L7.68242 11.4048L7.68242 18.469" stroke="#19191C"/> </svg>',
    },
    misc:{
      plus: '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M14 7L-2.55076e-07 7" stroke="#19191C"/> <path d="M7 0L7 14" stroke="#19191C"/> </svg>',
    },
    optionPanel: {
      plus: '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M14 7L-2.55076e-07 7" stroke="#19191C"/> <path d="M7 0L7 14" stroke="#19191C"/> </svg>',
      minus: '<svg width="14" height="14" viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M14 1L-2.55076e-07 0.999999" stroke="#19191C"/> </svg>',
    },
  }
  }; 
  
  
  window.mimeeqCustomMessages = {
    'canvasside.zoomall': 'Aan scherm aanpassen',
    'canvasside.zoomin': "Vergrößern",
    'canvasside.zoomout': "Verkleinern",
  };